import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import s from './index.module.scss'
import { svgIcons } from '../../utils/svg-icons'
import Linkify from 'react-linkify'

const TEXT_MAX_HEIGHT = 67

const ExpandableText: React.FC<{ title: string; text: React.ReactNode }> = ({ title, text }) => {
    const [needExpand, setNeedExpand] = useState(false)
    const [isExpanded, setIsExpanded] = useState(false)

    const textRef = useRef<HTMLParagraphElement>(null)

    useEffect(() => {
        if (!textRef.current) return

        const timerId = setTimeout(() => setNeedExpand(textRef.current!.offsetHeight > TEXT_MAX_HEIGHT), 0)
        return () => clearTimeout(timerId)
    }, [textRef, text])

    return (
        <div className={classNames(s.expandableText, { [s.needExpand]: needExpand }, { [s.expanded]: isExpanded })}>
            <div className={s.overflow} style={{ maxHeight: needExpand ? `${TEXT_MAX_HEIGHT}px` : 'max-content' }}>
                <p ref={textRef}>
                    <b>{title}: </b>
                    <Linkify>{text}</Linkify>
                </p>
            </div>
            {needExpand && <button onClick={() => setIsExpanded((prev) => !prev)}>{svgIcons.arrow}</button>}
        </div>
    )
}

export default ExpandableText
